import * as actions from './actions'
import { success, failure, reset } from 'utilities/actions'

export type State = {
  data: any;
  errors: any[];
  meta: any;
  message?: string | null;
  redirect?: string | null | undefined;
  requestSent: boolean;
};

type Action = {
  type: string;
  data?: any;
  errors?: any[];
  meta?: any;
  message?: string | null;
  redirect?: string | null | undefined;
};

const initialState = {
  data: {},
  errors: [],
  meta: {},
  requestSent: false,
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly data: {}; readonly errors: readonly []; readonly meta: {}; readonly requestSent: false; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case success(actions.API_PASSWORD_RESET_REQUESTS_SHOW):
      return { ...state, data: action.data, meta: action.meta }
    case success(actions.API_PASSWORD_RESET_REQUESTS_CREATE):
      return { ...state, data: action.data, message: null, requestSent: true }
    case success(actions.API_PASSWORD_RESETS_RESETS_CREATE):
      return { ...state, data: action.data }
    case failure(actions.API_PASSWORD_RESET_REQUESTS_CREATE):
    case failure(actions.API_PASSWORD_RESET_REQUESTS_SHOW):
    case failure(actions.API_PASSWORD_RESETS_RESETS_CREATE):
      return { ...state, errors: action.errors, requestSent: false }
    case reset(actions.API_PASSWORD_RESETS_RESETS_CREATE):
      return { ...state, ...initialState }
    default:
      return state
  }
}

export default reducer
